import { CLIENT_SITE_URL } from '../lib/config.js';

/** The sentence when the API's own message is missing. */
export const WORKSPACE_ACCESS_FALLBACK =
  'This account does not have access to the Production workspace yet. Ask ScoutAround to enable it through the contact page.';

/** Where a person without access is sent to ask for it. */
export const CONTACT_URL = `${CLIENT_SITE_URL}/contact`;

/**
 * The answer to 403 WORKSPACE_ROLE_REQUIRED: the account is signed in, but
 * ScoutAround has not enabled the Production workspace for it.
 *
 * NOTHING HERE OFFERS TO TRY AGAIN. Retrying, signing in again or accepting an
 * invitation changes nothing (ADR 0010: an invitation never grants the role);
 * the only way on is to ask, so the contact page is the primary action and the
 * client site the way out.
 */
export function WorkspaceAccessRequired({
  testId,
  message,
  heading,
}: {
  testId: string;
  /** The API's sentence; the fallback when it sent none. */
  message: string | null;
  heading?: string;
}) {
  return (
    <div data-testid={testId}>
      {heading === undefined ? null : (
        <h2 className="dh" style={{ fontSize: 26, marginTop: 10 }} data-testid={`${testId}-heading`}>
          {heading}
        </h2>
      )}
      <p className="mm" style={{ fontSize: 13, marginTop: 10, lineHeight: 1.6 }} data-testid={`${testId}-message`}>
        {message !== null && message !== '' ? message : WORKSPACE_ACCESS_FALLBACK}
      </p>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 16 }}>
        <a className="btn btn-primary" href={CONTACT_URL} data-testid={`${testId}-contact`}>
          Contact ScoutAround
        </a>
        <a className="btn btn-ghost" href={`${CLIENT_SITE_URL}/`} data-testid={`${testId}-home`}>
          Back to ScoutAround
        </a>
      </div>
    </div>
  );
}
